import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
// import { useAppContext } from 'Main';

const CardDropdown = ({ btnRevealClass, drop, align = 'start', children, icon = 'ellipsis-h', popperConfig, boundary = 'viewport' }) => {
	// const {
	// 	config: { isRTL },
	// } = useAppContext();

	const resolvedPopperConfig = popperConfig ?? { strategy: 'fixed' };

	return (
		<Dropdown className='font-sans-serif btn-reveal-trigger' align={align} drop={drop}>
			<Dropdown.Toggle
				variant='reveal'
				size='sm'
				data-boundary={boundary}
				className={classNames('text-600', {
					[btnRevealClass]: btnRevealClass,
					'btn-reveal': !btnRevealClass,
				})}
			>
				<FontAwesomeIcon icon={icon} className='fs-11' />
			</Dropdown.Toggle>
			<Dropdown.Menu className='border py-0' popperConfig={resolvedPopperConfig} renderOnMount>
				{children}
				{!children && (
					<div className='py-2'>
						<Dropdown.Item>View</Dropdown.Item>
						<Dropdown.Item>Export</Dropdown.Item>
						<Dropdown.Divider />
						<Dropdown.Item className='text-danger'>Remove</Dropdown.Item>
					</div>
				)}
			</Dropdown.Menu>
		</Dropdown>
	);
};

CardDropdown.propTypes = {
	btnRevealClass: PropTypes.string,
	drop: PropTypes.string,
	align: PropTypes.string,
	children: PropTypes.node,
	icon: PropTypes.string,
	popperConfig: PropTypes.object,
	boundary: PropTypes.string,
};

export default CardDropdown;
